export default {
  Lang: {
    de: 'German',
    en: 'English'
  },
  Action: {
    add: 'Add',
    edit: 'Edit',
    remove: 'Remove',
    close: 'Close',
    select: 'Select',
    save: 'Save',
    saving: 'Saving',
    send: 'Send',
    confirmSelection: 'Confirm selection',
    change: 'Change',
    changeSelection: 'Change selection',
    next: 'Next',
    prev: 'Previous',
    finish: 'Finish',
    search: 'Search',
    usePrevious: 'Use Previous',
    download: 'Download',
    removeAttachment: 'Delete file?',
  },
  Common: {
    start: 'Start',
    date: 'Date',
    name: 'Name',
    noSelection: 'No selection',
    creationdate: 'Creation date',
    lastmodified: 'Last modified',
    status: 'Status',
    color: 'Color',
    settings: 'Settings',
    masterdata: 'Master data',
    masterdataSaved: 'Master data saved',
    amount: 'Amount',
    description: 'Description',
    notice: 'Notice',
    item: 'Item',
    itemNum: 'Item no.',
    itemName: 'Item name',
    itemPrice: 'Item price',
    quantity: 'Quantity',
    singlePrice: 'Sellingprice',
    discount: 'Discount',
    rebate: 'Rebate',
    vat: 'VAT',
    total: 'Total',
    misc: 'Miscellaneous',
    orderPrice: 'Order price',
    annotation: 'Annotation',
    accountDetails: 'Account details',
    customerNum: 'Customer no.',
    salutation: 'Title',
    firstname: 'Firstname',
    lastname: 'Lastname',
    company: 'Company',
    email: 'Email',
    contact: 'Contact',
    address: 'Street',
    postalcode: 'Postalcode',
    city: 'City',
    country: 'Country',
    taxDetails: 'Tax details',
    vatId: 'VAT ID',
    noEntries: 'No entries',
    showAll: 'Show all',
    languageSettings: 'Language settings',
    showXtoYentries: 'Showing {x} to {y} results',
    showXtoYofZentries: 'Showing {x} to {y} out of {z} results',
    error: 'Error',
    errorSavingMasterdata: 'Could not save masterdata.',
    errorIncomplete: 'Incomplete form',
    errorFieldMissing: '{field} is missing',
    errorUploadInvalidResp: 'Invalid server response. Please try again or contact our support.',
    required: 'Value is required',
    loading: 'Loading...',
    phone: 'Phone',
    phone2: 'Phone 2',
    cancelled: 'Cancelled',
  },
  Units: {
    C62: 'pcs.',
    GRM: 'g'
  },
  Dashboard: {
    title: 'Dashboard'
  },
  Addresses: {
    title: 'Addresses',
    add: 'New Address',
    addressMain: 'Main address',
    addressBilling: 'Billing address',
    addressShipping: 'Shipping address',
    confirmRemove: 'Do you really want to remove this address?',
    errorLoad: 'Address could not be loaded.',
    errorRemove: 'Address could not be removed.'
  },
  EditAddress: {
    title: 'New Address',
    errorTypeTitle: 'Please specify an address type.',
    errorTypeText: 'The address must be a billing and/or shipping address.',
    errorCreate: 'Could not create address.',
    errorUpdate: 'Could not update address',
    shipping: 'Shipping',
    useForShippingNo: 'Do not use for shipping',
    useForShippingYes: 'Use as shipping address',
    useForShippingDefault: 'Use as default shipping address',
    billing: 'Billing',
    useForBillingNo: 'Do not use for billing',
    useForBillingYes: 'Use as billing address',
    useForBillingDefault: 'Use as default billing address'
  },
  Packages: {
    title: 'Packages'
  },
  Projects: {
    title: 'Projects',
    loading: 'Loading projects',
    currentProjects: 'Current projects',
    showAll: 'Show all projects',
    noProjects: 'No projects',
    add: 'Add project',
    projectNumber: 'Project no.',
    projectName: 'Project name',
    projectType: 'Project type',
    statusAll: 'All projects',
    statusOpen: 'Open projects',
    statusOrdered: 'Ordered projects',
    errorNoName: 'Please specify a project name.',
    errorCreate: 'Project could not be created.',
    errorCouldNotLoad: 'Could not load project.'
  },
  ProjectDetails: {
    title: 'Project details',
    loading: 'Loading project',
    saving: 'Saving project',
    saved: 'Project saved',
    alertOrdered: 'Project ordered:',
    openOrder: 'Open order',
    alertReference: 'This project references a preceeding project:',
    openProject: 'Open project',
    toothSelection: 'Tooth selection',
    noConstruction: 'No construction',
    editConstruction: 'Edit construction',
    materialSelection: 'Material selection',
    estimatedDelivery: 'Estimated delivery',
    missingMaterial: 'Material selection is missing',
    missingAttachments: 'Missing attachments',
    addStl: 'Add STL',
    openCart: 'Open cart',
    emptyCart: 'Empty cart',
    shippingType: 'Shipping method',
    construction: 'Construction',
    stlUpload: 'STL upload',
    attachments: 'Attachments',
    cart: 'Cart',
    addItem: 'Add item',
    orderProject: 'Order project',
    statusNotOrdered: 'Not ordered',
    statusOrdered: 'Ordered',
    statusExpired: 'Expired',
    statusReview: 'Review',
    statusApproved: 'Approved',
    statusRejected: 'Rejected',
    errorNoProjectnum: 'No valid project number',
    addons: 'Addons',
    orderOptions: 'Additional order options',
    approval: 'Approval',
    reject: 'Reject proposal',
    approve: 'Approve proposal',
    confirmRejection: 'Are you sure you want to reject this proposal?',
    confirmApproval: 'Are you sure you want to approve this proposal?',
    warningRejectMessage: 'Please provide a reason for the rejection in the comment field!',
    hasBeenRejected: 'The project proposal has been rejected!',
    hasBeenApproved: 'The project proposal has been approved!',
    selectorLayersIncomplete: 'Please check you selections',
    supplierName: 'Supplier',
    errorCouldNotLoad: 'Project could not be loaded.',
    errrorInvalidServerResponse: 'Invalid server response.',
    errorCouldNotSave: 'Project could not be saved.',
    removing: 'Removing project',
    removed: 'Project removed',
    errorCouldNotRemove: 'Project could not be removed.',
    orderSuccessful: 'Order {order} successful!',
    costs: 'Project costs',
    calculcatingPrices: 'Calculating prices',
    errorCouldNotCalcDuedate: 'The duedate could not be calculated',
    confirmSave: 'Are you sure you want to save the project?',
    clickToMakeSelection: 'Click on cell or tooth to start selection',
    secondClickToCompleteSelection: 'Click on cell or tooth to complete selection',
    messages: 'Chat',
    OK: 'Maxillary',
    UK: 'Mandibular',
  },
  Orders: {
    title: 'Orders',
    loading: 'Loading orders',
    currentOrders: 'Current orders',
    openOrder: 'Open order',
    showAll: 'Show all orders',
    noOrders: 'No orders',
    orderNum: 'Order no.',
    projectRef: 'Project ref.',
    extRef: 'External ref.',
    statusAll: 'All orders',
    statusNotOrdered: 'Not ordered',
    statusReceived: 'Received',
    statusReceivedDescr: 'Your order is being reviewed',
    statusInProgress: 'In progress',
    statusInProgressDescr: 'Your order is being processed',
    statusInProduction: 'In production',
    statusInProductionDescr: 'Production has started',
    statusOnHold: 'On hold',
    statusCancelled: 'Cancelled',
    statusCancelledDescr: 'Your order has been cancelled',
    statusClosed: 'Closed',
    statusCompleted: 'Completed',
    statusCompletedDescr: 'Your order has been completed!',
    statusInvoicedCancelled: 'Invoiced / cancelled',
    statusPartlyDelivered: 'Partly delivered',
    statusPartlyDeliveredCancelled: 'Partly delivered / cancelled',
    statusPartlyDeliveredClosed: 'Partly delivered / closed',
    statusDelivered: 'Shipped',
    statusDeliveredDescr: 'Your order has been shipped',
    statusInvoiced: 'Invoiced',
    statusReadyForPickup: 'Ready for pickup',
    errorCouldNotLoad: 'Could not load order'
  },
  OrderDetails: {
    title: 'Order details',
    deliveryNote: 'Delivery note',
    loading: 'Loading order',
    trackingNum: 'Tracking no.',
    manufacturingStatus: 'Manufacturing status',
    trackingAndBilling: 'Tracking and billing',
    creatingOrder: 'Creating order',
    orderProject: 'Order project',
    placeOrder: 'Place order',
    acceptTerms: 'I have read and accepted the <a href="{termsUrl}" target="_blank">Terms of Service</a>.',
    errorNoOrderNum: 'Invalid order number',
    errorCouldNotLoad: 'Could not load order',
    priceNobleMetal1: 'The final product price for noble metals is calculated based on the product\'s final weight.',
    priceNobleMetal2: 'Please check your delivery note once you receive the shippment for further details.',
    files: 'Files',
    allCategories: 'All categories'
  },
  Messages: {
    title: 'Messages',
    noMessages: 'No messages',
    errorCouldNotLoad: 'Could not load messages',
    writeSomething: 'Write something...',
    errorSendingMessage: 'Error sending message.'
  },
  Configurator: {
    selectIndication: 'Select indication',
    changeMaterial: 'Change material',
    selectTooth: 'Please select a tooth',
    showToothNumbers: 'Show tooth numbers',
    toothSelection: 'Tooth selection',
    setProductProps: 'Set product properties',
    selectProduct: 'Select product',
    fileXofY: 'File {x} of {y}',
    calcPrice: 'Calculating prices',
    uploadStl: 'Upload STL',
    stlCount: 'Unit count for this STL',
    stlCountTooltip: 'Please select the number of units for this STL,',
    oneUnit: 'One unit',
    nUnits: '{n} units',
    removeJawSelection: 'Do you want to remove the product selection for this jaw?',
    invalidTeethInRange: 'The {0} teeth is invalid for range {1}-{2}.',
    invalidRange: 'The {0}-{1} tooth range is invalid. The start/end teeth have to be on the same jaw.',
    invalidTeethNumber: 'The {0} is invalid teeth number.',
    transferSettings: 'Do you want to transfer those settings to multiple teeth?',
    clickOnConnectTooth: 'Click on the tooth you want to connect to'
  },
  Invoices: {
    title: 'Invoices',
    loading: 'Loading invoices',
    invoiceNum: 'Invoice no.',
    monthlyStatement: 'Monthly statement',
    statusReceived: 'Received',
    statusOpen: 'Open',
    statusHold: 'On hold',
    statusCancelled: 'Cancelled',
    statusClosed: 'Closed',
    statusPartlyPaid: 'Partly paid',
    statusPartlyPaidCancelled: 'Partly paid / cancelled',
    statusPartlyPaidClosed: 'Partly paid / closed',
    statusPaid: 'Paid'
  },
  File: {
    name: 'File name',
    hash: 'File hash',
    size: 'File size',
    messageUpload: 'Click field or drag/drop file to upload',
    allFilesSameMaterial: 'All files have the same material',
    preparingData: 'Preparing data',
    sendingData: 'Sending data',
    processingData: 'Processing data',
    errorUpload: 'An error occured. Could not upload file.',
    errorCouldNotList: 'Could not load files.',
    errorCouldNotLoad: 'Could not load file.',
    errorCouldNotDelete: 'Could not delete files.',
    waiting: 'Waiting...',
  },
  Login: {
    username: 'Email or customer number',
    password: 'Password',
    passwordOld: 'Old password',
    passwordNew: 'New password',
    passwordConfirm: 'Confirm new password',
    passwordSaved: 'Password updated',
    recover: 'Reset password',
    checkEmailForRecoverLink: 'We have sent you an e-mail to reset your password.',
    newPassword: 'New password',
    confirmPassword: 'Confirm password',
    change: 'Change password',
    back: '< Back to Login',
    login: 'Login',
    logout: 'Logout',
    enterPwd: 'Please enter your password',
    invalidUserOrPwd: 'Invalid username or password',
    errorCouldNotUpdate: 'Could not update password.',
    errorPasswordNoMatch: 'Passwords do not match.',
    errorOldPassword: 'Your old password is wrong.',
    errorNoSession: 'No active user session found. Please log in.'
  },
  Infothek: {
    title: 'Infothek',
    loading: 'Loading...',
    noContent: 'Sorry, there is no content available for your current language',
  },
  CookieConsent: {
    header: 'We value your privacy.',
    message: 'This website uses cookies to ensure you get the best possible experience on our website. Intergrated third-party services may consolidate this information with further data. Cookies may contain personal data unless explicitly specified otherwise. By clicking "Select all and close", you agree to the use of these cookies and save your settings for the specified storage period. Alternatively, you can select which specific cookies you\'d like to enable and save your settings by clicking "confirm selection". You can find further information as well as the possibility of regulatory objections in our <a href="https://bredent-group.com/privacy-policy/">Privacy Policy</a>.',
    dismiss: 'Got it!',
    allow: 'Allow cookies',
    deny: 'Decline',
    link: 'Learn more',
    policy: 'Cookie Policy',
    acceptSelection: 'Confirm selection',
    acceptAll: 'Select all and close',
    analytics: 'Analytics (stored for 2 years)',
    required: 'Required (stored indefinitely)',
    services: 'Services',
    servicesDescription: {
      cookieconsent: 'Stores the user’s cookie consent state for the current domain (no personal data)',
      laravel: 'Preserves user session state across page requests',
      XSRFTOKEN: 'Security token for form and file submissions (no personal data)',
      cfduid: 'Used by the content network, Cloudflare, to identify trusted web traffic',
      sentry: 'Provided by sentry.io for error reporting',
      googleAnalytics: 'General usage statistics',
      youtube: 'Usage statistics when viewing embedded videos'
    }
  },
};
